import { render, staticRenderFns } from "./SysUserIntegralForm.vue?vue&type=template&id=3391babd"
import script from "./SysUserIntegralForm.vue?vue&type=script&lang=js"
export * from "./SysUserIntegralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports